import React, { Component } from 'react'
import { Card, CardContent, CardTitle } from '../../../Components'
import styled from 'styled-components'
import { format } from 'date-fns'
import { ParametroPreProjetoModel } from '../../../Store'
/*
  interfaces
*/
interface IProps {
  faseAtual: number
  parametros: ParametroPreProjetoModel
}

const StyledTitle = styled(CardTitle)`
  font-size: 20px;
  padding: 24px 24px 0px 24px;
`

const StyledSubTitle = styled(CardTitle)`
  padding: 10px 24px 0px 24px;
`

const StyledCardContent = styled(CardContent)`
  padding: 0px 24px 0px 24px;
`

export default class InstrucoesPreProjetoCard extends Component<IProps> {

  getPeriodoDaFase = () => {
    const { faseAtual, parametros } = this.props
    if (faseAtual == 1) return [parametros.dataDeInicioPF, parametros.dataDeFimPF]
    if (faseAtual == 2) return [parametros.dataDeInicioSF, parametros.dataDeFimSF]
    if (faseAtual == 3) return [parametros.dataDeInicioTF, parametros.dataDeFimTF]
    return [0, 0]
  }

  render() {
    const { faseAtual } = this.props

    return (
      <Card>
        <StyledTitle>Instruções: </StyledTitle>
        <StyledSubTitle>{faseAtual}ª fase de seleção.</StyledSubTitle>
        <StyledSubTitle>Periodo de seleção: {format(this.getPeriodoDaFase()[0], 'DD/MM/YYYY')} a {format(this.getPeriodoDaFase()[1], 'DD/MM/YYYY')}.</StyledSubTitle>
        <StyledCardContent>
          <ul>
            <li>Professor, analise aqui os pré-projetos dos alunos que manifestaram interesse pela sua orientação e selecione aqui seus orientandos.</li>
            <li><b>Importante:</b> se deseja que o aluno seja encaminhado a outro orientador, registre "orientação não aceita".</li>
            <li>
              Evite deixar a seleção pendente. Se a seleção permanecer "pendente" e o professor não recusar a orientação,
              o aluno poderá ser considerado automaticamente aprovado, caso ainda existam vagas disponíveis ao orientador.
            </li>
            <li>
              <a target="blank" href="https://www.direitosbc.br/wp-content/uploads/2017/08/Res_3_2009.pdf">Clique aqui</a> para conferir a Resolução sobre o trabalho de conclusão de curso (TCC).
            </li>
          </ul>
        </StyledCardContent>
      </Card>
    )
  }
}